
import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import RoleBasedProfileForm from '@/components/profile/RoleBasedProfileForm';
import { useAuth } from '@/hooks/useAuth';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { Navigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import ErrorBoundary from '@/components/ErrorBoundary';
import { Loader2 } from 'lucide-react';

const ProfileEdit = () => {
  const { user: supabaseUser, profile, loading: authLoading } = useAuth();
  const { user: internalUser, loading: internalLoading } = useInternalAuth();
  const isMobile = useIsMobile();

  // Debug logs
  useEffect(() => {
    console.log('ProfileEdit - Page loaded');
    console.log('ProfileEdit - Supabase user:', supabaseUser?.id);
    console.log('ProfileEdit - Internal user:', internalUser?.id);
    console.log('ProfileEdit - Profile:', profile);
    console.log('ProfileEdit - Auth loading:', authLoading, 'Internal loading:', internalLoading);
  }, [supabaseUser, internalUser, profile, authLoading, internalLoading]);

  // Show loading state while authentication is being determined
  const isLoading = authLoading || internalLoading;
  
  // If no user is logged in, redirect to login
  if (!isLoading && !supabaseUser && !internalUser) {
    console.log('ProfileEdit - No user found, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Show appropriate header based on device */}
      {isMobile ? <MobileHeader /> : <Header />}
      
      <main className={`${
        isMobile 
          ? 'pt-20 pb-20 px-4' 
          : 'pt-28 pb-6 px-4 md:px-6'
      }`}>
        <div className="max-w-6xl mx-auto">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-sports-green mb-2">Advanced Profile Edit</h1>
            <p className="text-gray-400">Update your detailed profile information and settings</p>
          </div>
          
          {/* Loading State */}
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-sports-green mb-4" />
              <p className="text-gray-400">Loading your profile...</p>
            </div>
          ) : (
            <ErrorBoundary>
              <RoleBasedProfileForm />
            </ErrorBoundary>
          )}
        </div>
      </main>
      
      {!isMobile && <Footer />}
      <MobileBottomNav />
    </div>
  );
};

export default ProfileEdit;
